var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.facets && _vm.facets.length > 0,
          expression: "facets && facets.length > 0",
        },
      ],
      staticClass: "bkFilters bkr-cc",
    },
    [
      _vm.filterOpen
        ? _c("div", {
            staticClass: "filterShadow",
            on: { click: _vm.toggleFilter },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn btn-sm btn-bkm-inverted facetToggleButton",
          class: { active: _vm.activeFacets > 0 },
          on: { click: _vm.toggleFilter },
        },
        [
          _c("i", {
            staticClass: "fa fa-sliders default-float mr-2",
            attrs: { "aria-hidden": "true" },
          }),
          _vm._v(
            " " + _vm._s(_vm.$translate("Ceres::Template.itemFilter")) + " "
          ),
          _vm.activeFacets > 0
            ? _c("span", {
                domProps: { innerHTML: _vm._s(" (" + _vm.activeFacets + ")") },
              })
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "filter-wrapper", attrs: { "aria-modal": "true" } },
        [
          _c(
            "div",
            {
              staticClass: "filter-collapse",
              class: { show: _vm.filterOpen },
              attrs: { inert: !_vm.filterOpen },
              on: { defaultOpen: _vm.toggleFilter },
            },
            [
              _vm.isLoading
                ? _c("div", { staticClass: "filterLoading" }, [_vm._m(0)])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "page-content component-loading",
                  class: { isLoading: _vm.isLoading },
                },
                [
                  _c("span", { staticClass: "filterHeading" }, [
                    _vm._v("Filtern"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "facetOutter",
                      attrs: { selectedFactes: _vm.selectedFacets.length },
                    },
                    _vm._l(_vm.facets, function (facet) {
                      return _c("item-filter", {
                        key: facet.id,
                        attrs: { facet: facet },
                      })
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "filterBtnRow" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-bkm mb-2 applyFilterButton",
                        attrs: { type: "button" },
                        on: { click: _vm.toggleFilter },
                      },
                      [
                        _c("span", [_vm._v("Suchergebnis")]),
                        _vm._v(" "),
                        _c("i", {
                          staticClass: "fa fa-arrow-right ml-2",
                          attrs: { "aria-hidden": "true" },
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass:
                          "btn btn-bkm-inverted btn-sm applyFilterButton",
                        attrs: { type: "button" },
                        on: { click: _vm.resetAllTags },
                      },
                      [
                        _c("span", [_vm._v("Zurücksetzen")]),
                        _vm._v(" "),
                        _c("i", {
                          staticClass: "fa fa-refresh ml-2",
                          attrs: { "aria-hidden": "true" },
                        }),
                      ]
                    ),
                  ]),
                ]
              ),
            ]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "bkLoading" }, [
      _c("div"),
      _c("div"),
      _c("div"),
      _c("div"),
      _c("div"),
      _c("div"),
      _c("div"),
      _c("div"),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }